export default __webpack_public_path__ + "static/media/bad.d19fa497.svg";